


































































































































import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Auth } from '@view/a-login/login-controlador';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    constructor() {
        super();
    }

    @Prop()
    public Abierto: boolean;
    @Watch( 'Abierto', { immediate: true } )
    onAbierto() { this.MenuAbierto = this.Abierto; }

    public menuAbierto: boolean = this.$vuetify.breakpoint.smAndUp;
    public set MenuAbierto( e: boolean ) {
        this.menuAbierto = e;
        if ( this.Abierto != e )
            this.$emit( 'menu-changed', e );

    }

    public get MenuAbierto(): boolean {

        return this.menuAbierto;
    }

    public Mini: boolean = this.$vuetify.breakpoint.md;
    @Watch( 'Mini', { immediate: true } )
    onMini() {
        if ( this.Mini ) {

            for ( let i of document.getElementsByClassName( 'v-navigation-drawer__content' ) ) {
                i.className += ' no-scroll';
            }

        } else {

            for ( let i of document.getElementsByClassName( 'v-navigation-drawer__content' ) ) {
                i.className = i.className.eliminar( ' no-scroll' );
            }

        }
    }



    public Menus: Array<{ Titulo?: string; Item?: string; Icono?: string; Link?: string; }> = [

        { Item: "Inicio", Link: '/', Icono: 'home' },
        { Item: "Cursos", Link: '/cursos', Icono: 'school' },
        { Titulo: "Ventas" },
        { Item: "Pedidos", Link: '/pedidos', Icono: 'cart' },
        { Item: "Pagos", Link: '/pagos', Icono: 'bank' },
        { Titulo: "Artículos" },
        { Item: "Publicaciones", Link: '/publicaciones', Icono: 'sale' },
        { Item: "Preguntas", Link: '/preguntas', Icono: 'sale' },

    ];

    public abrirChat() {
        if ( this.$vuetify.breakpoint.xsOnly ) {
            this.$router.push( '/chat' );
        } else {
            this.$router.push( '/chat' );
            //this.$EventBus.$emit( 'abrir-chat' );
        }

    }
    public async CerrarSesion() {

        if ( await this.$EventBus.Mensajes.SiNo( "Cerrar sesión", "¿Está seguro de cerrar la sesión actual?", 'Aceptar' ) ) {

            await Auth.CerrarSesion();
            this.$EventBus.Notificaciones.Alerta( 'Se cerro la sesión' );
            this.$router.push( '/login' );

        }

    }
}
